import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, finalize,catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { EMPTY } from 'rxjs';
import { AuthenticationService } from '../_services/authentification.service';

import { LoadingService } from '../_services/loading.service';
import { ToastrService} from 'ngx-toastr';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    activeRequests: number = 0;
    errorCodeServer: number = 0;
    errorCode: number = 0;

    constructor(private authenticationService: AuthenticationService,
                private cookieService: CookieService,
                private loadingService: LoadingService,
                private toastr: ToastrService) { }
    // constructor() { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.errorCodeServer = 0;
        this.errorCode = 0;
         try {
            let valCookie = this.cookieService.get(environment.app);
            if (!valCookie) {
                // validar sesion
                console.log("Cookie sin valor interceptor");
                this.goLogin();
                return EMPTY;
            }
            let separador = "-";
            let segementos: string[] = valCookie.split(separador);
            if (segementos && segementos.length == 3) {
                let currentUser = this.authenticationService.currentUserValue;

                if (!request.headers.has('Cache-Control')) {
                    request = request.clone({ headers: request.headers.set('Cache-Control', 'no-cache') });
                }

                if (!request.headers.has('Pragma')) {
                    request = request.clone({ headers: request.headers.set('Pragma', 'no-cache') });
                }

                if (!request.headers.has('withCredentials')) {
                    request = request.clone({ headers: request.headers.set('withCredentials', 'true') });
                }

                if (!request.headers.has('Access-Control-Allow-Origin')) {
                    request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });
                }

                if (!request.headers.has('user')) {
                    request = request.clone({ headers: request.headers.set('user', btoa(segementos[2])) });
                }

                if (!request.headers.has('rol')) {
                    request = request.clone({ headers: request.headers.set('rol', btoa(segementos[0])) });
                }

                if (!request.headers.has('token')) {
                    request = request.clone({ headers: request.headers.set('token', segementos[1]) });
                }

                if (!request.headers.has('Esquema') && currentUser) {
                    request = request.clone({ headers: request.headers.set('Esquema', currentUser.idEsquema) });
                }

                if (!request.headers.has('Version') && currentUser) {
                    request = request.clone({ headers: request.headers.set('Version', environment.version) });
                }
            }
        } catch (e) {
            console.log("No se detecto sesion");
            // validar sesion
            this.goLogin();
            return EMPTY;
        }

        // activa loading
        if (this.activeRequests === 0) {
            this.loadingService.startLoading();
        }
        this.activeRequests++;

        return next.handle(request)
        .pipe( map( (event: HttpEvent<any>) => {
            
                if (event instanceof HttpResponse) {
                    if (event.status != this.errorCode) {
                        //  200=ok 201=created
                        if( event.status == 200 || event.status == 201)  {

                            if( event.body && event.body.responseMessage && event.body.responsecode != 0) {
                                this.toastr.warning('<h5>Mensaje de sistema...</h5> <span>' + event.body.responseMessage + '</span>', "", 
                                {closeButton:false, enableHtml:true, disableTimeOut:false});
                            }
                            

                        } else if( event.status == 401 ) {
                            console.error('--!> Servicio no autorizado ...');
                            this.toastr.error('<h5>Acceso denegado ...</h5> <span>No se puede tener acceso al servidor.</span>', "", 
                                {closeButton:true, enableHtml:true, disableTimeOut:true});
                                this.goLogin();                            
                        } else {
                            this.toastr.error('<h5>Error de sistema ..</h5> <span>A ocurrido un error interno en el sistema, intente nuevamente.</span>', "", 
                                {closeButton:true, enableHtml:true, disableTimeOut:true});
                        }
                    
                        this.errorCode = event.status;
                    }            
                }               

                return event;
        }, finalize(() => {
            // Desactiva loading
            this.activeRequests--;
            if (this.activeRequests === 0) {
                this.loadingService.stopLoading();
            }
        }))
        , catchError((error: HttpErrorResponse) => {
            if (error.status == 401) {                
                console.error('--!> Servicio no autorizado ...');
                this.toastr.error('<h5>Acceso denegado ...</h5> <span>No se puede tener acceso al servidor.</span>', "", 
                    {closeButton:true, enableHtml:true, disableTimeOut:true});
                    this.goLogin();  
            } else if (error.status != this.errorCodeServer) {            
                this.toastr.error('<h5>Error con la comunicación del servidor.</h5> <span>Revise su conexión de red y refresque su navegador web</span>', "", 
                    {closeButton:true, enableHtml:true, disableTimeOut:true});
                    this.errorCodeServer = error.status;
            } else if (error.status == undefined && this.errorCodeServer == 0) {
                this.toastr.error('<h5>Error de autenticaci&oacute;n.</h5> <span>Usuario y/o contraseña incorrectos</span>', "", 
                    {closeButton:true, enableHtml:true, disableTimeOut:true});
                    this.errorCodeServer = error.status;
            }
            return throwError(error);
        })            
        ) // end pipe         

        .pipe(
            finalize(() => {
                // Desactiva loading
                this.activeRequests--;
                if (this.activeRequests === 0) {
                    this.loadingService.stopLoading();
                }
            })
        ) // end pipe        
    }

    goLogin() {
        console.log("Redireccionando a login.");
        window.location.href = environment.uris.comunes.login;
    }
}